import { post } from './agent';

export default {
  create: (body) => post('/quote-request', body),
};
